import { Table, Text } from '@nimbus-ds/components';
import { TrashIcon } from '@nimbus-ds/icons';
import { MetaplanItemResponseDto } from '@tiendanube/common';
import { ActionIconButton, InternalNavLink } from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { SubscriptionConditions } from 'domains/Catalog/Subscriptions/components';

interface MetaplansListDesktopRowProps {
  metaplan: MetaplanItemResponseDto;
}

export function MetaplansListDesktopRow({
  metaplan: { id, name, subscriptionOptions },
}: Readonly<MetaplansListDesktopRowProps>) {
  const t = useTranslationCatalog();

  const handleDelete = (): void => {
    // TODO(juanrevello): Implement delete modal and action (ETA: Nov 2025, week 1)
  };

  return (
    <Table.Row>
      <Table.Cell backgroundColor="neutral-background">
        <Text lineClamp={1} fontWeight="medium">
          <InternalNavLink to={id}>
            <Text color="primary-interactive" fontWeight="regular">
              {name}
            </Text>
          </InternalNavLink>
        </Text>
      </Table.Cell>
      <Table.Cell backgroundColor="neutral-background">
        <SubscriptionConditions subscriptionOptions={subscriptionOptions} />
      </Table.Cell>
      <Table.Cell backgroundColor="neutral-background">
        <ActionIconButton
          content={t('subscriptions.table.deleteMetaplan')}
          source={<TrashIcon />}
          onClick={handleDelete}
        />
      </Table.Cell>
    </Table.Row>
  );
}
